<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="6" v-for="image in newItemData.images" :key="image.id">
        <image-item :image="image" @removed="removeImage" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ImageItem from '@/components/Settings/Landing/Roadmap/Edit/Tabs/ImagesTab/ImageItem'
export default {
  name: 'ImagesTab',
  components: {
    ImageItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    newItemData: {},
  }),
  mounted () {
    this.newItemData = this.item
  },
  methods: {
    removeImage (imageId) {
      const imgIdx = this.newItemData.images.findIndex(i => i.id === imageId)
      if (imgIdx !== false) {
        this.newItemData.images.splice(imgIdx, 1)
      }
    },
  },
}
</script>
